import type { BadgeVariant } from "@/components/ui/badge";

import { CONSTANTS_COPY } from "@/lib/ui-labels";
export const ALL_FILTER_VALUE = "all";

export const LOCATIONS = {
  lab1:    { label: CONSTANTS_COPY.lab1,   variant: "lab1"    },
  lab2:    { label: CONSTANTS_COPY.lab2,   variant: "lab2"    },
  storage: { label: "Storage", variant: "storage" },
} as const;

export type LocationKey = keyof typeof LOCATIONS;

export function locationLabel(key: string): string {
  return key in LOCATIONS ? LOCATIONS[key as LocationKey].label : key;
}
export function locationVariant(key: string): BadgeVariant {
  return key in LOCATIONS ? LOCATIONS[key as LocationKey].variant : "default";
}

export const ROLES = {
  admin:   { label: "Admin",   variant: "destructive" },
  manager: { label: "Manager", variant: "default"     },
  chemist: { label: "Chemist", variant: "outline"     },
} as const;

export type RoleKey = keyof typeof ROLES;

export function roleLabel(key: string): string {
  const lower = key?.toLowerCase();
  return lower in ROLES ? ROLES[lower as RoleKey].label : key;
}

export const CONTACT_TYPE_META = {
  supplier: { label: "Supplier", variant: "secondary" },
  purchaser: { label: "Purchaser", variant: "outline" },
  supplier_and_purchaser: { label: CONSTANTS_COPY.supplierPurchaser, variant: "default" },
} as const;

export type ContactTypeKey = keyof typeof CONTACT_TYPE_META;

export function contactTypeLabel(key: string): string {
  return key in CONTACT_TYPE_META ? CONTACT_TYPE_META[key as ContactTypeKey].label : key;
}
export function contactTypeVariant(key: string): BadgeVariant {
  return key in CONTACT_TYPE_META ? CONTACT_TYPE_META[key as ContactTypeKey].variant : "default";
}
export function roleVariant(key: string): BadgeVariant {
  const lower = key?.toLowerCase();
  return lower in ROLES ? ROLES[lower as RoleKey].variant : "outline";
}

export const ROLE_OPTIONS = Object.entries(ROLES).map(([value, { label }]) => ({ value, label }));

export const CHANGE_TYPES = {
  CREATED:            { label: "Added",    variant: "added"   },
  UPDATED:            { label: "Updated",  variant: "updated" },
  DELETED:            { label: "Deleted",  variant: "deleted" },
  INVENTORY_PURCHASE: { label: "Purchase", variant: "added"   },
  INVENTORY_SALE:     { label: "Sale",     variant: "deleted" },
  INVENTORY_USAGE:    { label: "Usage",    variant: "updated" },
  INVENTORY_DISPOSAL: { label: "Disposal", variant: "deleted" },
} as const;

export type ChangeTypeKey = keyof typeof CHANGE_TYPES;

export function changeTypeLabel(key: string): string {
  return key in CHANGE_TYPES ? CHANGE_TYPES[key as ChangeTypeKey].label : key;
}
export function changeTypeVariant(key: string): BadgeVariant {
  return key in CHANGE_TYPES ? CHANGE_TYPES[key as ChangeTypeKey].variant : "default";
}

export { UNITS, type Unit } from "@shared/inventory/units";

export const TABLE_DEFAULT_COLUMN_WIDTH_REM = 10;
export const TABLE_ACTIONS_COLUMN_WIDTH_REM = 9;
export const TABLE_ACTIONS_COMPACT_WIDTH_REM = 3;
export const PHONE_CARD_PAGE_SIZE = 10;
export const ORDERS_TABLE_ACTIONS_WIDTH_REM = 13;
export const TRUNCATED_TEXT_TOOLTIP_DELAY_MS = 300;
export const FORM_CONTROL_TEXT_CLASS_NAME = "text-base md:text-sm";
export const WRAPPING_ROW_CLASS_NAME = "flex min-w-0 flex-wrap items-center";
export const PHONE_TAP_HEIGHT_CLASS_NAME = "h-11";
export const PHONE_TAP_TARGET_CLASS_NAME = `${PHONE_TAP_HEIGHT_CLASS_NAME} w-11`;
export const PHONE_FULL_WIDTH_ACTION_CLASS_NAME = `${PHONE_TAP_HEIGHT_CLASS_NAME} w-full`;
export const ROW_ACTION_SIZE_CLASS_NAME = `${PHONE_TAP_TARGET_CLASS_NAME} md:h-8 md:w-8`;
export const ROW_MENU_TRIGGER_CLASS_NAME = `${ROW_ACTION_SIZE_CLASS_NAME} text-muted-foreground hover:text-foreground hover:bg-muted`;

export const LABEL_TEST_IDS = {
  label: "batch-label",
  page: "label-page",
  slot: "label-slot",
  qr: "qr-code",
} as const;
export const LABEL_PRINT_ROOT_ATTRIBUTE = "data-label-print-root";
